// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"154":"33cdc92481f0f887","953":"512e9ebb8d6e9c46"}[chunkId] + ".js";
};